import { AnyAction } from "redux";
import Graph from "../../models/graph";
import { distanceType } from "../../models/types";
import { GraphState } from "./type";

export const SET_GRAPH = "SET_GRAPH";
export const SET_DISTANCE_TYPE = "SET_DISTANCE_TYPE";
export const SET_ACTIVE_ITEM = "SET_ACTIVE_ITEM";
export const SET_SHOW_LINK_DOTS = "SET_SHOW_LINK_DOTS";
export const SET_SHOW_PROPERTIES = "SET_SHOW_PROPERTIES";
export const SET_ANSWERS = "SET_ANSWERS";

const initialState: GraphState = {
  graph: new Graph(),
  activeItem: null,
  showLinkDots: false,
  showProperties: false,
  distanceType: distanceType.BY_COORDINATES,
  answers: [],
};

const graphReducer = (
  state = initialState,
  { type, payload }: AnyAction
): GraphState => {
  switch (type) {
    case SET_GRAPH: {
      return {
        ...state,
        graph: payload,
      };
    }

    case SET_ACTIVE_ITEM: {
      return {
        ...state,
        activeItem: payload,
      };
    }

    case SET_DISTANCE_TYPE: {
      return {
        ...state,
        distanceType: payload,
      };
    }

    case SET_SHOW_LINK_DOTS: {
      return {
        ...state,
        showLinkDots: payload,
      };
    }

    case SET_SHOW_PROPERTIES: {
      return {
        ...state,
        showProperties: payload,
      };
    }

    case SET_ANSWERS: {
      return {
        ...state,
        answers: payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default graphReducer;
